// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.y2P_sx{height:100%;overflow-y:auto;transition:transform .3s ease-out;background:rgba(20,20,20,0.8);box-shadow:0 4px 8px rgba(0,0,0,0.12),0 0 4px rgba(0,0,0,0.1);border-radius:4px;min-height:60px;transform:translateY(calc(100% - 60px))}.y2P_sx.ZZd6wN{min-height:96px;transform:translateY(calc(100% - 96px))}.y2P_sx.h2YewQ{min-height:132px;transform:translateY(calc(100% - 132px))}.y2P_sx.KzWD6E{transform:translateY(0)}
`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"main": `y2P_sx`,
	"twoItem": `ZZd6wN`,
	"threeItem": `h2YewQ`,
	"open": `KzWD6E`
};
export default ___CSS_LOADER_EXPORT___;
